import { forwardRef } from 'react'
import { Box, useMediaQuery } from '@mui/material'
import { useTheme } from '@emotion/react'
import TalentMonthlyCalendar from '../components/TalentMonthlyCalendar'

const TalentCalendarContent = forwardRef(({ calendarValue }, ref) => {
  const theme = useTheme()
  const tablet = useMediaQuery(theme.breakpoints.up('tablet'))

  //Quick hack to fix double scroll mobile view uiux issue.
  //This is for mobile view.
  // if (!tablet) {
  //   return (
  //     <Box pb={2} overflow="hidden">
  //       <Box bgcolor="white.main" my={2} borderBottom="1px solid #E5E5E5">
  //         <TalentMonthlyCalendar ref={ref} calendarValue={calendarValue} />
  //       </Box>
  //     </Box>
  //   )
  // }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        borderBottom: '1px solid #E5E5E5',
        overflow: 'auto',
        maxHeight: { xs: 'calc(100vh - 200px)', md: 'calc(100vh - 197px)' },
        bgcolor: 'white.main',
        width: 1,
      }}
      className="scrollbar"
    >
      <TalentMonthlyCalendar ref={ref} calendarValue={calendarValue} />
    </Box>
  )
})

export default TalentCalendarContent
